import { Binder } from '@/models/binder.model';
import { BinderService } from '@/services/api/binder.service';
import {
  Component,
  effect,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-map-settings',
  standalone: true,
  templateUrl: './map-settings.component.html',
  styleUrl: './map-settings.component.scss'
})

export class MapSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('mapContainer', { static: true }) mapContainer!: ElementRef<HTMLDivElement>;
  map!: mapboxgl.Map;
  accessToken = environment.mapBox.accessToken;

  constructor(private binderService: BinderService) {
    effect(() => {
      const binder = this.binderService.currentBinder();
      if (binder) {
        this.setBinderCenter(binder);
      }
    });
  }

  mapView = {
    center: { lng: -122.431297, lat: 37.773972 },
    zoom: 14,
    bearing: 0,
    pitch: 0
  };

  ngOnInit(): void {
    this.initalizeMap();
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
    }
  }

async setBinderCenter(binder: Binder) {
  const address = binder.SiteAddress + ' ' + binder.SiteCity + ' ' + binder.SiteState + ' ' + binder.SiteZip;

  console.log('address', address);
  const encodedAddress = encodeURIComponent(address);
  const geocodeUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedAddress}.json?access_token=${this.accessToken}`;

  try {
    const response = await fetch(geocodeUrl);
    const data = await response.json();
    console.log('response data', data);

    if (data.features && data.features.length > 0) {
      const [lng, lat] = data.features[0].center;
      this.map.setCenter([lng, lat]);
      this.map.setZoom(15); // Adjust zoom as needed
      console.log(`Map centered on ${address}:`, { lat, lng });
    } else {
      console.warn('No results found for address:', address);
    }
  } catch (error) {
    console.error('Geocoding failed:', error);
  }
}

  initalizeMap() {
    this.map = new mapboxgl.Map({
      accessToken: this.accessToken, // ✅ add this here
      container: this.mapContainer.nativeElement,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [this.mapView.center.lng, this.mapView.center.lat],
      zoom: this.mapView.zoom,
      bearing: this.mapView.bearing,
      pitch: this.mapView.pitch
    });

    this.map.addControl(new mapboxgl.NavigationControl());
  }

  saveView(): void {
    const center = this.map.getCenter();
    this.mapView = {
      center: { lng: center.lng, lat: center.lat },
      zoom: this.map.getZoom(),
      bearing: this.map.getBearing(),
      pitch: this.map.getPitch()
    };
    console.log('Saved map view:', this.mapView);
    // Save to backend or emit an event if needed
  }
}
